export default "__VITE_ASSET__0e84b4c1__"